export default __webpack_public_path__ + "static/media/eagle-express.91d0e520.svg";